import React from 'react';
import * as S from './CtaCard.styles';

/**
 * Commercial CTA card for how-to-play pages (teal gradient + orange pill button).
 *
 * Props:
 *  - title: string
 *  - text?: string
 *  - buttonText: string
 *  - href: string
 */
const CtaCard = ({ title, text, buttonText, href }) => {
  return (
    <S.Card>
      {title && <S.Title>{title}</S.Title>}
      {text && <S.Text>{text}</S.Text>}
      {buttonText && href && <S.Button href={href}>{buttonText}</S.Button>}
    </S.Card>
  );
};

export default CtaCard;
